import React from 'react'
import headerImage from '../../assets/img/banners/Manage_Classes_Cover.jpg'
import ImageHeader from '../../components/ImageHeader'
import Section from './Section'
import Breadcrumbs from '../../components/Breadcrumbs'
import RosterList from './RosterList'
import { EmeraldHost } from '../../config'
import loadingGif from '../../assets/img/loading-pinwheel.gif'

//importing related to onboarding guide
import {OnboardingGuideBanner} from '../../components/OnboardingHomepage'
import { OnboardingTeacherContext } from '../../contexts/OnboardingTeacherContextProvider'
import _ from 'lodash'

const ClassManagement = props => {
  const { handleFetchRosters, handleResetSectionPasswords, handleUpsertStudents, importClassroomStudents, handleGoogleImportPopupClose, fetchGoogleClassrooms, handleUpdateSection, handleUpdateCourse, handleSubmitNewSection, handleDeleteStudents, handleFetchSection, handleTransferStudents, handleClearTransferErrors, handleVisitTargetSection } = props // functions

  const { isResettingPasswords, isUpsertingStudents, wasGoogleImportSuccessful, isImporting, isGooglePopupOpen, isClassroomFetching, isUpdatingSection, isUpdatingCourse, isCreatingSection, isSectionFetching, isRosterFetching, isDeletingStudents, isTransferringStudents } = props //passed-down state

  const { passwordResetErrors, upsertStudentsErrors, importErrors, classroomFetchErrors, updateSectionErrors, updateCourseErrors, createSectionErrors, rosterFetchErrors, sectionFetchErrors, deleteStudentsErrors, transferStudentsErrors } = props //errors

const {  googleClassrooms, googleAuthorizationLink,  courseCollection, currentUser, currentAction, selectedCourse,  section, rosters, course, activityIndicator } = props // data

  const getBreadcrumbItems = ()=> {
    switch(currentAction) {
      case 'LIST':
        return [{ text: 'Classes' }]
        break;
      case 'SHOW':
        return [{ text: 'Classes', link: '/classes' }, { text: section.name }]
        break;
    }
  }

  const {isAllComplete} = React.useContext(OnboardingTeacherContext)

  return(
    <ImageHeader image={headerImage}
      titleContents={<span><span className='semi-bold'>manage</span> classes</span>}
      subtitleText='organize your students' containerSection='courses-container'>
      <div className='courses-container'>
        {currentUser['is-educator'] && !isAllComplete? <div style={{'marginBottom':'32px'}}><OnboardingGuideBanner /></div> : null}
        <Breadcrumbs items={getBreadcrumbItems()}/>

        {/*Only educators need access to class management. All other users manage their relevant subaccounts through the Accounts page*/}
        {!currentUser['is-educator'] && (window.location = EmeraldHost()+`/account`) }

        {/* Roster List */}
        {currentUser['is-educator'] && currentAction == 'LIST' &&
          <div>
            {isRosterFetching && <img className='loading-gif' src={loadingGif}/>}
            {rosterFetchErrors.length > 0 &&
              <div className='roster-errors'>
                <h2>Sorry, something went wrong!</h2>
                <p>{rosterFetchErrors.join()}</p>
              </div>
            }
            {!rosterFetchErrors.length > 0 &&
              <RosterList
                rosters={rosters}
                selectedCourse={course}

                handleSubmitNewSection={handleSubmitNewSection}
                isCreatingSection={isCreatingSection}
                createSectionErrors={createSectionErrors}

                handleUpdateCourse={handleUpdateCourse}
                isUpdatingCourse={isUpdatingCourse}
                updateCourseErrors={updateCourseErrors}
              />
            }
          </div>
        }

        {/* Single Section (roster) */}
        {currentUser['is-educator'] && currentAction == 'SHOW' && !isSectionFetching &&
          <div>
            {sectionFetchErrors.length > 0 &&
              <div className='roster-errors'>
                <h2>Sorry, something went wrong!</h2>
                <p>{sectionFetchErrors.join()}</p>
              </div>
            }
            {!sectionFetchErrors.length > 0 &&
              <Section
                section={section}
                courseCollection={courseCollection}
                activityIndicator={activityIndicator}

                wasGoogleImportSuccessful={wasGoogleImportSuccessful}
                googleAuthorizationLink={googleAuthorizationLink}
                importClassroomStudents={importClassroomStudents}
                isImporting={isImporting}
                importErrors={importErrors}
                googleClassrooms={googleClassrooms}
                fetchGoogleClassrooms={fetchGoogleClassrooms}
                isClassroomFetching={isClassroomFetching}
                classroomFetchErrors={classroomFetchErrors}
                isGooglePopupOpen={isGooglePopupOpen}
                handleGoogleImportPopupClose={handleGoogleImportPopupClose}

                handleResetSectionPasswords={handleResetSectionPasswords}
                isResettingPasswords={isResettingPasswords}
                passwordResetErrors={passwordResetErrors}

                handleUpsertStudents={handleUpsertStudents}
                isUpsertingStudents={isUpsertingStudents}
                upsertStudentsErrors={upsertStudentsErrors}

                handleUpdateSection={handleUpdateSection}
                isUpdatingSection={isUpdatingSection}
                updateSectionErrors={updateSectionErrors}

                handleFetchRosters={handleFetchRosters}
                rosters={rosters}

                handleDeleteStudents={handleDeleteStudents}
                isDeletingStudents={isDeletingStudents}
                deleteStudentsErrors={deleteStudentsErrors}

                handleTransferStudents={handleTransferStudents}
                isTransferringStudents={isTransferringStudents}
                transferStudentsErrors={transferStudentsErrors}
                handleClearTransferErrors={handleClearTransferErrors}
                handleVisitTargetSection={handleVisitTargetSection}

                handleFetchSection={handleFetchSection}
              />
            }
          </div>
        }
      </div>
    </ImageHeader>
  );
}

export default ClassManagement
